import { connect } from "react-redux";
// Component
import EditModal from "components/SetupAttr/EditAttrModal";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
// Action
import {
  registEditAttrModal,
  closeEditAttrModal,
  discardEditAttr,
  updateEditAttrName,
  updateSetupAttrAttrItemOrder,
  addSetupAttrAttrItem,
  removeSetupAttrAttrItem,
  changeSetupAttrAttrItem
} from "redux/modules/setupAttr";

const mapStateToProps = state => ({
  editAttrModal: state.setupAttr.editAttrModal,
  locales: state.setupAttr.locales,
  localeNo: state.setupAttr.localeNo
});

const mapDispatchToProps = dispatch => ({
  handleRegist: attrId => {
    dispatch(registEditAttrModal(attrId));
    dispatch(closeEditAttrModal());
  },
  // 閉じる
  handleClose: () => dispatch(closeEditAttrModal()),
  discard: attrId => {
    const dialogData = {
      title: "確認",
      contentText: "初期設定に戻します。よろしいですか？",
      btnLabel: "実行",
      handleClick: () => {
        dispatch(discardEditAttr(attrId));
        dispatch(closeConfirmDialog());
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  changeAttrItemOrder: (attrItem, index, atIndex) => {
    dispatch(updateSetupAttrAttrItemOrder(attrItem, index, atIndex));
  },
  addNewAttrItem: () => {
    dispatch(addSetupAttrAttrItem());
  },
  removeAttrItem: index => {
    dispatch(removeSetupAttrAttrItem(index));
  },
  changeAttrName: attrName => {
    dispatch(updateEditAttrName(attrName));
  },
  changeAttrItem: (index, value) => {
    dispatch(changeSetupAttrAttrItem(index, value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(EditModal);



// WEBPACK FOOTER //
// ./src/containers/SetupAttr/EditAttrModalContainer.js